import { createContext, useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { Formatter } from '../../core/types/formatter.js';
import type { TreeMapFormatter } from '../types/internal.js';
import { getAppliedFormatter } from '../utils/get-applied-formatter.js';

export type FormatterContextProps = {
  /**
   * Custom or default formatter for the chart
   * @defaultValue the default formatter
   */
  formatter: TreeMapFormatter;
  /**
   * Truncation mode to use (start, middle, end)
   * Applied to all the parts that truncate text.
   * @defaultValue 'middle'
   */
  truncationMode: TruncationMode;
};

export const FormatterContext = createContext<FormatterContextProps>({
  formatter: () => '',
  truncationMode: 'middle',
});

export const useFormatter = (): Formatter => {
  const { formatter } = useContext(FormatterContext);

  return getAppliedFormatter(formatter);
};

